// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.provider_menu .cabinet_submenu li {\n    border-top: none !important;\n}\n.provider_menu .cabinet_submenu li a {\n    font-size: 14px;\n    color: var(--grey-color);\n}\n.provider_menu .cabinet_submenu li a:active {\n    background: transparent;\n}\n.provider_menu .cabinet_submenu li a:hover {\n    background: transparent;\n}\n", ""]);
// Exports
module.exports = exports;
